import { FC } from 'react';
import { Typography, Button } from '@material-ui/core';
import { FilterList } from '@material-ui/icons';
import cx from 'classnames';

const LoaderFilterButton: FC = () => {
  return (
    <Button
      data-testid="filters"
      variant="outlined"
      color="secondary"
      size="small"
      classes={{
        root: cx('ml-4 h-[32px] min-h-[32px] items-baseline'),
      }}
    >
      <div className="flex items-center justify-between pt-[2px]">
        <FilterList
          color="primary"
          style={{ width: 18, height: 18, padding: 2 }}
        />
        <Typography variant="body2" className="py-[2px]">
          Filter
        </Typography>
      </div>
    </Button>
  );
};

export default LoaderFilterButton;
